module.exports = __webpack_public_path__ + "media/images/placeholder-circle-small-63d37966e6cdab5b2cd1436ce5aedc18.png";